import { action, makeObservable } from "mobx";
import { MrbBaseListViewStore } from "mrb/core";
import { MrbTableViewStore } from "mrb/components";
import { mrbDefaultFormats } from "mrb/common/formatting";
import { localizationService } from "common/localization";
import { applicationDefaults } from "common/constants";

class LoadioContentProfileListViewStore extends MrbBaseListViewStore {
    constructor(rootStore, { routeStore }) {
        super(rootStore, {
            layoutActions: {
                create: {
                    onClick: () =>
                        rootStore.routerStore.goTo("master.administration.loadio-dashboard.profile.create"),
                    label: "ADMINISTRATION.LOADIO_DASHBOARD.PROFILES.CREATE_BUTTON",
                },
            },
            queryConfig: {
                orderBy: "dateUpdated",
                orderDirection: "desc",
            },
        });
        makeObservable(this);
        this.routeStore = routeStore;

        this.setGridStore(
            new MrbTableViewStore(this.rootStore, this.queryUtility, {
                onRowClick: (node) =>
                    this.rootStore.routerStore.goTo(
                        "master.administration.loadio-dashboard.profile.artists",
                        { id: node.data.id }
                    ),
                columns: [
                    {
                        key: "name",
                        title: "ADMINISTRATION.LOADIO_DASHBOARD.PROFILES.COLUMNS.NAME",
                        sortable: true,
                    },
                    {
                        key: "deviceCount",
                        title: "ADMINISTRATION.LOADIO_DASHBOARD.PROFILES.COLUMNS.DEVICE_COUNT",
                    },
                    {
                        key: "dateUpdated",
                        title: "ADMINISTRATION.LOADIO_DASHBOARD.PROFILES.COLUMNS.LAST_UPDATED",
                        sortable: true,
                        format: {
                            type: mrbDefaultFormats.date,
                            format: applicationDefaults.formats.date,
                        },
                    },
                ],
                actions: {
                    edit: {
                        onClick: (item) =>
                            this.rootStore.routerStore.goTo(
                                "master.administration.loadio-dashboard.profile.edit",
                                { id: item.id }
                            ),
                        label: "ADMINISTRATION.LOADIO_DASHBOARD.PROFILES.ACTIONS.EDIT",
                        buttonProps: {
                            className: "c-btn c-btn--sml c-btn--ghost u-mar--right--tny",
                        },
                    },
                    delete: {
                        onClick: (item) => this.deleteProfile(item),
                        label: "ADMINISTRATION.LOADIO_DASHBOARD.PROFILES.ACTIONS.DELETE",
                        buttonProps: {
                            className: "c-btn c-btn--sml c-btn--ghost",
                        },
                    },
                },
            })
        );
    }

    find(params) {
        return this.routeStore.findProfiles(params);
    }

    @action.bound
    async deleteProfile(item) {
        let deviceCount = 0;
        try {
            deviceCount = await this.routeStore.getDeviceCount(item.id);
        } catch (err) {
            this.rootStore.notificationStore.error(
                "An unexpected error occurred. Unable to retrieve device count.",
                err
            );
            return;
        }

        const message =
            deviceCount > 0
                ? localizationService.t("ADMINISTRATION.LOADIO_DASHBOARD.PROFILES.DELETE_DEVICE_WARNING", {
                      count: deviceCount,
                  })
                : localizationService.t("ADMINISTRATION.LOADIO_DASHBOARD.PROFILES.DELETE_CONFIRM");

        this.rootStore.confirmDialogStore.showConfirm({
            message,
            onConfirm: async () => {
                try {
                    await this.routeStore.deleteProfile(item);
                    this.queryUtility.fetch();
                } catch (err) {
                    this.rootStore.notificationStore.error(
                        "An unexpected error occurred. Unable to delete content profile.",
                        err
                    );
                }
            },
            yesLabel: "Delete",
            noLabel: "Cancel",
        });
    }

    onFetchError(err) {
        this.rootStore.notificationStore.error(
            "An unexpected error occurred while trying to load data. Please contact the support team.",
            err
        );
    }
}

export default LoadioContentProfileListViewStore;
